__turbopack_context__.v({
  "divider": "-RbX0a_divider",
  "mobileBar": "-RbX0a_mobileBar",
  "mobileControlSlot": "-RbX0a_mobileControlSlot",
  "mobileItem": "-RbX0a_mobileItem",
  "mobileItemIndicator": "-RbX0a_mobileItemIndicator",
  "mobileMenuSlot": "-RbX0a_mobileMenuSlot",
  "section": "-RbX0a_section",
  "tabsSection": "-RbX0a_tabsSection",
  "title": "-RbX0a_title",
  "topbar": "-RbX0a_topbar",
});
